import { scheduling } from '@morf/proto/scheduling/v1/scheduling_ts_proto';

const convertToHyphenatedLowerCase = (str: string): string => {
  return str.toLowerCase().replace(/_/g, '-');
};

export const getViewTypeFromPath = (
  asPath: string
): keyof typeof scheduling.v1.SchedulingApplicationViewType => {
  const viewTypeKeys = Object.keys(
    scheduling.v1.SchedulingApplicationViewType
  ) as Array<keyof typeof scheduling.v1.SchedulingApplicationViewType>;

  for (const viewType of viewTypeKeys) {
    const hyphenatedKey = convertToHyphenatedLowerCase(viewType);

    if (asPath.includes(hyphenatedKey)) {
      return viewType;
    }
  }

  return 'ILLEGAL_UNSPECIFIED_VIEW_TYPE';
};
